import { NhanVien } from "../models/employees.model";
import { QuayBanCuaHang, CuaHangBillFormat } from "../models/store_stalls.model";
import { BgColors } from "../models/bg_color.model";
import { Logo } from "../models/logo.model";
import { HangHoa } from "../models/product.model";
import { HTTT } from "../models/bill.model";
import { SuKienGia } from "../models/sukiengia.model";


export function accountReducer(state: NhanVien = null, action: any): NhanVien {
  if (action.type === 'ADD_USER') {
    return action.user;
  }
  if (action.type === 'LOGOUT_USER') {
    return null;
  }
  return state;
}


export function storeReducer(state: QuayBanCuaHang = null, action: any): QuayBanCuaHang {
  if (action.type === 'ADD_STORE') {
    return action.store;
  }
  return state;
}

export function brcolorReducer(state: BgColors = null, action: any): BgColors {
  if (action.type === 'INIT_BG') {
    return action.bg;
  }
  return state;
}

export function fileNameLogoReducer(state: Logo, action: any): Logo {
  if (action.type === 'INIT_LOGO') {
    return action.lg;
  }
  return state;
}

export function HangHoaReducer(state: Array<HangHoa>, action: any): Array<HangHoa> {
  if (action.type === 'INIT_HangHoa') {
    return action.hh;
  }
  return state;
}

export function NhanVienReducer(state: Array<NhanVien>, action: any): Array<NhanVien> {
  if (action.type === 'INIT_NhanVien') {
    return action.nv;
  }
  return state;
}


export function HTTTReducer(state: Array<HTTT>, action: any): Array<HTTT> {
  if (action.type === 'INIT_HTTT') {
    return action.httt;
  }
  return state;
}

export function CuaHangReducer(state: Array<CuaHangBillFormat>, action: any): Array<CuaHangBillFormat> {
  if (action.type === 'INIT_CuaHang') {
    return action.ch;
  }
  return state;
}

export function SuKienGiaReducer(state: Array<SuKienGia>, action: any): Array<SuKienGia> {
  if (action.type === 'INIT_SuKienGia') {
    return action.skg;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/app/ngrx-store/reducer.ts